import { DictionaryDTO, SelectOption } from 'src/app/core/models/dictionary';
import { FiltersSidebarComponent } from '../components/filters-sidebar/filters-sidebar.component';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { Observable } from 'rxjs';
import { PeriodDateRangeId } from './index';

export interface FiltersConfig {
  title: string;
  filters: FilterField[];
  grouping?: GroupingConfig;
  savedFilters?: FilterValues;
  defaultFilters?: FilterValues;
  scrollToFilterKey?: string;
  onApply?: (filters: FilterValues, count: number) => void;
  onReset?: () => void;
  onComponentReady?: (component: FiltersSidebarComponent) => void;
}

export interface GroupingConfig {
  fields: GroupField[];
  defaultGroup?: GroupOption;
  required?: boolean;
  onChange?: (groupOptions: GroupOption | GroupOption[]) => void;
}

export interface GroupField {
  key: string;
  label: string;
  options: GroupOption[];
}

export interface GroupOption extends DictionaryDTO {
  key: string;
}

export interface FilterValues {
  [key: string]: string | number | (string | number)[] | string[];
}

export interface FilterResult {
  filters: FilterValues;
  count: number;
}

export interface ActiveFilterChip {
  key: string;
  label: string;
  /** Чип обязательного фильтра (нельзя удалить вручную) */
  required: boolean | undefined;
}

export interface FilterBarActionButton {
  icon: string;
  action: () => void;
  tooltip?: string;
  showLabel?: boolean;
  label?: string;
  inMenuOnly?: boolean;
}

export interface FilterField {
    /** ID параметра, который пойдет на бэк в таблице */
    dataKey: string;
    /** Тип поля фильтра */
    filterType: (typeof FilterTypes)[keyof typeof FilterTypes];
    /** Текст подсказки */
    hint?: string;
    /** Лейбл */
    label: string;
    /** Заглушка */
    placeholder?: string;
    /** Опции для выбора */
    selectOptions?: DictionaryDTO[];
    /** Опции пресетов периода для `date-range` */
    dateRangePeriodOptions?: SelectOption<PeriodDateRangeId>[];
    /** Показывать фильтр для селекта */
    showFilter?: boolean;
    /** Тег «ПРОФИ» */
    showProfiTag?: boolean;
    /** Заблокировать поле  */
    disabled?: boolean;
    /** Обязательное поле */
    required?: boolean;

    /** Метод для заполнения списка */
    completeMethod?: (
      event: AutoCompleteCompleteEvent,
    ) =>
      | Observable<DictionaryDTO[]>
      | Promise<DictionaryDTO[]>
      | DictionaryDTO[]
      | void;
}

export const FilterTypes = {
    Select: 'select',
    Autocomplete: 'autocomplete',
    Input: 'input',
    Date: 'date',
    Month: 'month',
    DateRange: 'date-range',
    MultiSelect: 'multi-select',
}
